import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
// Só o peso 500: a fonte display serve apenas os títulos das páginas públicas.
import '@fontsource/montserrat/500.css';
import '@/styles/tokens.css';
import '@/styles/global.css';
import { BlogApp } from './app/BlogApp';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento raiz #root não encontrado no documento.');
}

createRoot(container).render(
  <StrictMode>
    <BlogApp />
  </StrictMode>,
);
